import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import * as Ant from "antd";
import { ObjectId } from "@bluelibs/ejson";
import { Routes } from "@bundles/UIAppBundle";
import { useRouter, use, useDataOne, useTranslate } from "@bluelibs/x-ui";
import { TransactionEditForm } from "../../config/TransactionEditForm";
import { features } from "../../config/features";
import { TransactionsCollection, } from "@bundles/UIAppBundle/collections";
const renderNestedObject = (obj) => {
    if (obj) {
        return (_jsx("div", Object.assign({ className: "transaction-view-initial-data-container" }, { children: Object.keys(obj).map((key, keyIndex) => {
                if (typeof obj[key] === "string") {
                    return (_jsxs("div", { children: [_jsx("p", Object.assign({ className: "transaction-view-initial-data-bold" }, { children: key }), void 0), _jsx("p", { children: obj[key] }, void 0)] }, keyIndex));
                }
                else if (typeof obj[key] === "number") {
                    return (_jsxs("div", { children: [_jsx("p", Object.assign({ className: "transaction-view-initial-data-bold" }, { children: key }), void 0), _jsx("p", { children: obj[key] }, void 0)] }, keyIndex));
                }
                else if (typeof obj[key] === "object") {
                    if (Array.isArray(obj[key])) {
                        return (_jsxs("div", { children: [_jsx("p", Object.assign({ className: "transaction-view-initial-data-bold" }, { children: key }), void 0), _jsx(Ant.Col, { children: obj[key].map((arrVal, index) => (_jsx("p", { children: arrVal }, index))) }, void 0)] }, void 0));
                    }
                    else {
                        return renderNestedObject(obj[key]);
                    }
                }
            }) }), void 0));
    }
    else {
        return undefined;
    }
};
const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const formTailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
export const TransactionsEditWidget = ({ id, status, close, }) => {
    const t = useTranslate();
    const form = use(TransactionEditForm, { transient: true });
    const router = useRouter();
    const { data: document, isLoading, error, } = useDataOne(TransactionsCollection, new ObjectId(id), TransactionEditForm.getRequestBody());
    form.build();
    return (_jsxs(Ant.Modal, Object.assign({ width: 800, open: status, onCancel: close, footer: null, style: {
            top: 0,
            right: 0,
            padding: 0,
            position: "absolute",
            margin: "0px",
        }, bodyStyle: {
            height: "100vh",
            width: "100%",
            maxWidth: "800px",
            overflowY: "scroll",
            overflowX: "hidden",
        } }, { children: [_jsx(Ant.PageHeader, { title: t("management.transactions.edit.header"), extra: features.view
                    ? [
                        _jsx(Link, Object.assign({ to: router.path(Routes.TRANSACTIONS_VIEW, {
                                params: { id: id },
                            }) }, { children: _jsx(Ant.Button, { children: t("generics.view") }, void 0) }), "view"),
                    ]
                    : [] }, void 0), _jsxs(Ant.Card, { children: [isLoading && (_jsx(Ant.Space, Object.assign({ align: "center" }, { children: _jsx(Ant.Spin, { size: "large" }, void 0) }), void 0)), !isLoading && (error || !document) && (_jsx(Ant.Alert, { message: error || t("generics.error_message"), type: "error" }, void 0)), !isLoading && !error && (_jsxs(Ant.Form, Object.assign({}, formLayout, { requiredMark: "optional", initialValues: document, onFinish: (document) => form.onSubmit(id, document) }, { children: [form.render(), _jsx(Ant.Form.Item, Object.assign({}, formTailLayout, { children: _jsx(Ant.Button, Object.assign({ type: "primary", htmlType: "submit" }, { children: t("generics.submit") }), void 0) }), void 0)] }), void 0))] }, void 0)] }), void 0));
};
